import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ENDPOINTS } from "../../../utils/endPoints";
import { GET_API_CALL } from "../../../utils/services";
import ArticleForm from "../components/ArticleForm";
import { ArticleService } from "../action";
import ROUTE_NAMES from "../../../routes/routeNames";
import { CSpinner } from "@coreui/react";

const EditArticle = () => {
  const { articleId } = useParams();
  const navigate = useNavigate();
  const authReducer = useSelector((state) => state.AuthReducer);
  const [loading, setLoading] = React.useState(true);
  const [article, setArticle] = React.useState({
    _id: "",
    title: "",
    content: "",
    readTime: 0,
    tags: [],
    status: 0,
    publishAt: null,
    createdAt: "",
    createdBy: {
      _id: "",
      profileImage: "",
      name: "",
    },
    message: "",
    defaultImage: "",
    description: "",
  });

  React.useEffect(() => {
    GET_API_CALL(
      ENDPOINTS.ARTICLES.GET_ARTICLE_DETAILS,
      `?articleId=${articleId}`,
      (response) => {
        console.log("Article Details Response:", response);
        if (response.isSuccess) {
          const articleData = response.data;
          setArticle(articleData);
        } else {
          console.error("Failed to fetch article:", response.message);
        }
        setLoading(false);
      },
    );
  }, [articleId, authReducer, navigate]);
  console.log("article :", article);

  if (loading) {
    return (
      <div className="page-loader">
        <CSpinner
          color="primary"
          style={{ width: "3.5rem", height: "3.5rem" }}
        />
        <h2 className="page-loader__title">Loading Article</h2>
        <p className="page-loader__description">
          Please wait while we fetch the article details...
        </p>
      </div>
    );
  }

  return (
    <ArticleForm
      title="Editing this article"
      description="You're editing an article. Save to apply your changes."
      submitLabel="Update Article"
      initialTitle={article?.title}
      initialReadTime={article?.readTime}
      initialContent={article?.content}
      initialDescription={article?.description}
      initialStatus={article?.status}
      initialTags={article?.tags}
      initialBannerPreview={article?.defaultImage}
      submitHandler={async (values) => {
        const response = await ArticleService.updateArticles(
          article._id,
          values,
          article,
        );
        if (response) {
          navigate(ROUTE_NAMES.MAIN_ROUTES.ARTICLES);
        }
      }}
    />
  );
};

export default EditArticle;
